import { useContext } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';

//context
import {ListContext} from '@/context/ListContext';



const CombinedFeedWidget = () => {
    
    const {listId, appGuid, isMainMenu} = useContext(ListContext)

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.COMBINED_FEED} href={`/a/${appGuid}/Content?parentId=${listId}&contentType=CombinedFeed&position=${isMainMenu ? 'end' : 'start'}`} isNew/>
        </div>
    )
}
export default CombinedFeedWidget